( function () {
   
    'use strict';

    ( function ( $ ) {
        $('.our-portfolio-one').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:false,
            autoplaySpeed: 1500,
            arrows:true,
            variableWidth: true,
            centerMode:true,
            centerPadding:'30%',
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    infinite: true,
                }
            },
            {
                breakpoint:767,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    centerPadding: '30px',
                    centerMode: true,
                }
            }
            ]
        });
        $('.our-portfolio-one.rtl').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:false,
            autoplaySpeed: 1500,
            arrows:true,
            variableWidth: true,
            centerMode:true,
            centerPadding:'30%',
            rtl: true,
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    infinite: true,
                }
            },
            {
                breakpoint:767,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    centerPadding: '30px',
                    centerMode: true,
                }
            }
            ]
        });
       
        // if($('.video-overlay-content').length > 0){
                  
           
         
        // }
      
      
        
    } )( jQuery );
} )();

